<template>
  <div class="min-h-screen flex flex-col">
    <header class="bg-gradient-to-b from-indigo-950 via-purple-950 to-indigo-950 shadow-md py-4">
      <div class="container mx-auto px-4 flex justify-between items-center">
        <div class="flex items-center">
          <h1 class="text-xl font-bold text-white">Boredom Buster</h1>
        </div>
        <nav>
          <!-- P3功能，暂时隐藏 -->
          <router-link to="/" class="text-white/80 hover:text-white mx-2 transition-colors">Home</router-link>
          <router-link v-if="false" to="/manage" class="text-white/80 hover:text-white mx-2 transition-colors">Game Management</router-link>
          <router-link to="/about" class="text-white/80 hover:text-white mx-2 transition-colors">About</router-link>
        </nav>
      </div>
    </header>
    
    <main class="flex-grow">
      <router-view />
    </main>
    
    <footer class="bg-indigo-950 py-4">
      <div class="container mx-auto px-4 text-center text-gray-300 text-sm">
        &copy; {{ new Date().getFullYear() }} Boredom Buster - Random Game Recommendation Platform
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>